"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USAddressHelpers = void 0;
const types_1 = require("./types");
const DefaultAddressHelpers_1 = require("../DefaultAddressHelpers");
const utils_1 = require("./utils");
class StaticUsAddressHelpers extends DefaultAddressHelpers_1.StaticAddressHelpers {
    static formatAddress(address) {
        const addressTypes = {
            [types_1.AddressCategoryEnum.STANDARD]: (0, utils_1.formatStandardAddress)(address),
            [types_1.AddressCategoryEnum.MILITARY]: (0, utils_1.formatRuralMilitaryAddress)(address),
            [types_1.AddressCategoryEnum.RURAL]: (0, utils_1.formatRuralMilitaryAddress)(address),
        };
        return addressTypes[address.addressType] || (0, utils_1.formatStandardAddress)(address);
    }
    static validateAddress(address) {
        return Boolean(address);
    }
    static formatAddressForComponent(address) {
        return (0, utils_1.formatRuralMilitaryAddressForComponent)(address);
    }
}
StaticUsAddressHelpers.standardRegex = /^[\sA-Za-z0-9-./]+$/;
StaticUsAddressHelpers.additionalInfoRegex = /^(?=[A-Za-z0-9])([A-Za-z0-9]*([-/][A-Za-z0-9]+){0,2}[A-Za-z0-9]*)$/;
StaticUsAddressHelpers.militaryRegex = /^(UNIT|CMR|PSC) (\d{1,4}) BOX (\w{1,4})$/;
StaticUsAddressHelpers.ruralRegex = /^(\w{2}) (\d{1,4}) BOX (\w{1,4})$/;
StaticUsAddressHelpers.postalCodeRegex = /^(?!00000|99999)\d{5}$/;
StaticUsAddressHelpers.unitRouteRegex = /^\d+$/;
StaticUsAddressHelpers.boxRegex = /^[A-Za-z0-9]+(-[A-Za-z0-9]+)?$/;
StaticUsAddressHelpers.cityRegex = /^[A-Za-z\s.'’`´-]*$/;
StaticUsAddressHelpers.invalidPOBoxTerms = [
    'PO BOX',
    'P.O. BOX',
    'P.O.BOX',
    'P O BOX',
    'P.O BOX',
    'P.OBOX',
    'POBOX',
    'PO. BOX',
    'P O.BOX',
    'P O. BOX',
    'PBX',
    'PO BX',
    'Post Office Box',
    'Post Box',
    'BX',
    'P.O.B.',
    'P. O. B.',
    'P O B',
    'POB',
    'P. Box',
    'P Box',
    'P. Office Box',
    'P Office Box',
    'Box',
    'Office Box',
];
class USAddressHelpers extends StaticUsAddressHelpers {
    constructor() {
        super(...arguments);
        this.standardRegex = USAddressHelpers.standardRegex;
        this.additionalInfoRegex = USAddressHelpers.additionalInfoRegex;
        this.militaryRegex = USAddressHelpers.militaryRegex;
        this.ruralRegex = USAddressHelpers.ruralRegex;
        this.postalCodeRegex = USAddressHelpers.postalCodeRegex;
        this.unitRouteRegex = USAddressHelpers.unitRouteRegex;
        this.boxRegex = USAddressHelpers.boxRegex;
        this.cityRegex = USAddressHelpers.cityRegex;
        this.invalidPOBoxTerms = USAddressHelpers.invalidPOBoxTerms;
    }
    formatAddress(address) {
        return USAddressHelpers.formatAddress(address);
    }
    validateAddress(address) {
        return USAddressHelpers.validateAddress(address);
    }
    formatAddressForComponent(address) {
        return USAddressHelpers.formatAddressForComponent(address);
    }
}
exports.USAddressHelpers = USAddressHelpers;
//# sourceMappingURL=USAddressHelpers.js.map